import { SecLoanCarOwnershipType } from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'
import { buildOptionList } from '@ui-common/utils'
import { FormRadioGroup } from '@ui-components/form/FormRadioGroup'
import { FormTextInput } from '@ui-components/form/FormTextInput'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { getIfpApplicantInfoLocalizedEnums } from './applicantInfoStepUtils'
import { ApplicantInfoFormData } from './types'

export const ExpensesFormFields = () => {
  const { formatMessage } = useIntl()
  const { register, control } = useFormContext<ApplicantInfoFormData>()
  const { errors } = useFormState({
    name: [
      'ownShareOfHousingExpenses',
      'hasCarOwnership',
      'carOwnershipType',
      'totalLoansAmount',
      'totalAmountOfLoanRepaymentsPerMonth',
      'payingCompanyLoan',
      'totalHousingCompanyLoan',
    ],
    control,
  })
  const [selectedHasCarOwnership, payingCompanyLoan] = useWatch({
    name: ['hasCarOwnership', 'payingCompanyLoan'],
    control,
  })
  const { yesNoTexts, expenseInfoCarOwnershipLabelTexts } = getIfpApplicantInfoLocalizedEnums(formatMessage)

  return (
    <>
      <FormTextInput
        required={true}
        inputMode="decimal"
        label={formatMessage({ id: 'ifp-loans-applicant-info-own-share-of-housing-expenses-label' })}
        description={formatMessage({ id: 'ifp-loans-applicant-info-own-share-of-housing-expenses-description' })}
        error={errors?.ownShareOfHousingExpenses?.message}
        {...register('ownShareOfHousingExpenses')}
      />
      <FormRadioGroup
        label={formatMessage({ id: 'sec-loans-expenses-info-has-car-ownership-form-label' })}
        required={true}
        options={buildOptionList(Object.values(YesNo), yesNoTexts)}
        error={errors?.hasCarOwnership?.message}
        {...register('hasCarOwnership')}
      >
        {selectedHasCarOwnership === YesNo.Yes && (
          <FormRadioGroup
            label={formatMessage({ id: 'sec-loans-expenses-info-car-ownership-form-label' })}
            required={true}
            description={formatMessage({
              id: 'ifp-loans-applicant-info-car-ownership-type-description',
            })}
            options={buildOptionList(Object.values(SecLoanCarOwnershipType), expenseInfoCarOwnershipLabelTexts)}
            {...register('carOwnershipType')}
            error={errors.carOwnershipType?.message}
          />
        )}
      </FormRadioGroup>
      <FormTextInput
        required={true}
        inputMode="decimal"
        label={formatMessage({ id: 'ifp-loans-total-loans-amount-label' })}
        description={formatMessage({ id: 'ifp-loans-applicant-info-only-own-share-description' })}
        error={errors?.totalLoansAmount?.message}
        {...register('totalLoansAmount')}
      />
      <FormTextInput
        required={true}
        inputMode="decimal"
        label={formatMessage({ id: 'ifp-loans-applicant-info-total-amount-of-loan-repayments-per-month' })}
        description={formatMessage({ id: 'ifp-loans-applicant-info-only-own-share-description' })}
        error={errors?.totalAmountOfLoanRepaymentsPerMonth?.message}
        {...register('totalAmountOfLoanRepaymentsPerMonth')}
      />
      <FormRadioGroup
        label={formatMessage({ id: 'ifp-loans-applicant-info-paying-company-loan-label' })}
        required={true}
        options={buildOptionList(Object.values(YesNo), yesNoTexts)}
        error={errors.payingCompanyLoan?.message}
        {...register('payingCompanyLoan')}
      >
        {payingCompanyLoan === YesNo.Yes && (
          <FormTextInput
            required={true}
            inputMode="decimal"
            label={formatMessage({ id: 'ifp-loans-applicant-info-total-housing-company-loan' })}
            description={formatMessage({ id: 'ifp-loans-applicant-info-only-own-share-description' })}
            error={errors?.totalHousingCompanyLoan?.message}
            {...register('totalHousingCompanyLoan')}
          />
        )}
      </FormRadioGroup>
    </>
  )
}
